import React from "react";

const AppFooter = () => (
  <footer className="app-footer">
    <span>© {new Date().getFullYear()} Kare. Admin operations workspace.</span>
    <span>Secure patient and order management</span>
  </footer>
);

export default AppFooter;
